import { DownloadxmlShowmessage } from './../../model/downloadxml-showmessage';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { FileExportService } from './../../services/file-export.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PoTypesDto } from './../../model/po-types-dto';
import { Enablesaveuseraccessdto } from './../../model/enablesaveuseraccessdto';
import { MaterialAndQualityDto } from './../../model/material-and-quality-dto';
import { CreatePoDto } from './../../model/create-po-dto';
import { CustomerLocationIds } from './../../model/customer-location-ids';
import { PartnerDto } from './../../model/partner-dto';
import { HttpclientService } from './../../services/httpclient.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import xml2js from 'xml2js';

@Component({
  selector: 'app-create-test-po',
  templateUrl: './create-test-po.component.html',
  styleUrls: ['./create-test-po.component.css']
})
export class CreateTestPoComponent implements OnInit {
  modalPopup: boolean = false;
  loading: boolean;
  customerNameList: PartnerDto[];
  customerNameFilterList: PartnerDto[];
  customerModal: string = "";
  customerLocationIdsModel: string = "";
  customerPOType: string = "";
  poNumberModel: string;
  distributorModel: string;
  materialModel: string = "";
  materialModels: string[] = [];
  qtyModels: string[] = [];
  materialNQualityArray: MaterialAndQualityDto[] = [];
  poCreationResponse: string;
  isBulkModel: boolean = false;
  qtyModel: string;
  isValidData: string;
  customerLocationIdsList: CustomerLocationIds[];
  distibutorsList: CustomerLocationIds[];
  materialsList: CustomerLocationIds[];
  rowCountList: number[] = [];
  number: number = 1;
  noOfPO: number;
  isHidden: string;
  isDisabled: boolean = true;
  isDisabledDistributor: boolean = true;
  materialModelCount: number = 0;
  isStatus: boolean = false;
  poTypesDtoList: PoTypesDto[];
  isDownload;
  isPOTypeEnabled: boolean = false;

  constructor(private httpClient: HttpclientService, public fileExportService: FileExportService, private sanitizer: DomSanitizer, private appSetting: AppSettingService) {
    this.materialModels[this.materialModelCount] = "";
    this.qtyModels[this.materialModelCount] = "";
    this.materialNQualityArray[0] = new MaterialAndQualityDto("", "", "");
    this.rowCountList[0] = 0
    this.isDistributor = sessionStorage.getItem('roleId')!='6' ? false : true;
  }

  ngOnInit() {
    this.getCustomersName();
    // this.getPOTypes();

  }

  quantityCount: number = 0;
  isDistributor:boolean;


  addNum(index: number){    
    if(Number(this.materialNQualityArray[index].quality) >= 0){
     const oldValue = Number(this.materialNQualityArray[index].quality);
     this.qtyModels[index] = ""+(oldValue + 1);
    }    
    }
  
  subNum(index: number) {    
  if (Number(this.materialNQualityArray[index].quality) > 0){
    const oldValue = Number(this.materialNQualityArray[index].quality);
    this.qtyModels[index] = ""+(oldValue - 1);  
   }   
   }


  getPOTypes() {
    this.loading = true;
    this.httpClient.getPOTypes().subscribe(
      data => {
        this.poTypesDtoList = data;
        if (this.customerModal != this.appSetting.serviceKingId) {
          this.poTypesDtoList = this.poTypesDtoList.filter(h => h.poType === "Standard PO");
          this.customerPOType = "Standard PO";
          this.isPOTypeEnabled = true;
        } else {
          this.isPOTypeEnabled = false;
        }
        this.loading = false;
      }
    )
  }

  clearValidationMessage() {
    this.isValidData = "";
    this.materialNQualityArrayError = "";
    this.quantityCount = 0;
    this.poCreationResponse = "";
    this.isStatus = false;
    this.poCreationResponseList = [];
    this.poCreationXmlResponseList = [];
    this.isValidData = "";
    this.customerModalError = "";
    this.customerLocationIdsModelError = "";
    this.customerPOTypeError = "";
    this.poNumberModelError = "";
    this.noOfPOError = "";
    this.materialModelsError = "";
    this.qtyModelsError = [];
    this.materialNQualityArrayError = "";
    this.DownloadxmlShowmessageList = [];
  }

  viewXml(index) {
    var data = this.poCreationXmlResponseList[index];

    const blob = new Blob([data], { type: 'text/xml' });
    let url = URL.createObjectURL(blob);
    window.open(url, "_blank");
    URL.revokeObjectURL(url);
  }

  createPOAlert() {
    this.modalPopup = true;
  }
  pressingOK(checkBox, isHidden) {
    this.modalPopup = false;
    this.createPO(checkBox, isHidden);
  }
  customerModalError;
  customerLocationIdsModelError;
  customerPOTypeError;
  poNumberModelError;
  noOfPOError;
  materialModelsError;
  qtyModelsError: string[] = [];
  materialNQualityArrayError;
  createPO(checkBox, isHidden) {
    this.clearValidationMessage();
    // var Exp = /((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+[0-9a-z]+$/i;
    var Exp = "^[a-zA-Z0-9]+$";
    if (this.customerModal == "" || this.customerModal == null || this.customerModal == undefined) {
      this.customerModal = "";
      this.customerModalError = "Please choose Customer";
      return;
    }
    if (this.customerLocationIdsModel == "" || this.customerLocationIdsModel == null || this.customerLocationIdsModel == undefined) {
      this.customerLocationIdsModel = "";
      this.customerLocationIdsModelError = "Please choose Customer Location ID";
      return;
    }
    if (this.customerPOType == "" || this.customerPOType == null || this.customerPOType == undefined) {
      this.customerPOType = "";
      this.customerPOTypeError = "Please choose Customer PO Type";
      return;
    }

    if (this.poNumberModel == null || this.poNumberModel == "" || this.poNumberModel == undefined) {
      this.poNumberModel = "";
      this.poNumberModelError = "Please choose PO Number";
      return;
    }
    if (!this.poNumberModel.match(Exp)) {
      this.poNumberModel = "";
      this.poNumberModelError = "A valid PO Number must be Entered";
      return;
    }
    if (this.isHiddenEnabled == true) {
      if (this.noOfPO != undefined) {
        if (this.noOfPO.toString().includes("-")) {
          this.noOfPO = undefined;
          this.noOfPOError = "Number of PO Cannot Be Negative";
          return;
        }
        if (this.noOfPO.toString() == "") {
          this.noOfPO = undefined;
          this.noOfPOError = "A valid Integer must be Entered";
          return;
        }
        if (this.noOfPO.toString().includes(".")) {
          this.noOfPO = undefined;
          this.noOfPOError = "A valid Integer must be Entered";
          return;
        }
        if (this.noOfPO == 0) {
          this.noOfPO = undefined;
          this.noOfPOError = "A valid Integer must be Entered";
          return;
        }
      }
      if (this.noOfPO == undefined) {
        this.noOfPO = undefined;
        this.noOfPOError = "Please choose Number of PO";
        return;
      }
      var isNumber = Number(this.noOfPO);
      if (isNumber.toString() === "NaN") {
        this.noOfPO = undefined;
        this.noOfPOError = "A valid Integer must be Entered";
        return;
      }

    }
    // if(this.distributorModel == null || this.distributorModel == "" || this.distributorModel == undefined){
    //   this.distributorModel="";
    //   this.isValidData="Please choose Distributor";
    //   return; 
    // }

    var len1 = this.materialNQualityArray.length;
    for (var i = 0; i < len1; i++) {
      if ((this.materialNQualityArray[i].material === "" && this.materialNQualityArray[i].quality === "") || (this.materialNQualityArray[i].material === "" && this.materialNQualityArray[i].quality === null)) {
        this.materialNQualityArrayError = "Please choose Both Material And Quantity";
        return
      }
      else if (this.materialNQualityArray[i].material === "") {
        this.materialNQualityArrayError = "Please choose Material";
        return
      }
      else if (this.materialNQualityArray[i].quality === "") {
        this.materialNQualityArrayError = "Please choose  Quantity";
        return
      }
      else if (this.materialNQualityArray[i].quality === null) {
        this.materialNQualityArray[i].quality = "";
        this.materialNQualityArrayError = "Please choose  Quantity";
        return
      }
      else if (this.materialNQualityArray[i].quality.toString() === "0") {
        this.materialNQualityArray[i].quality = "";
        this.materialNQualityArrayError = "Quantity Can't be 0";
        return
      }
      if (this.materialNQualityArray[i].quality != null) {
        if (this.materialNQualityArray[i].quality.toString().includes("-")) {
          this.materialNQualityArrayError = "Quantity Cannot Be Negative";
          return
        }
      }

    }
    if (this.materialModels.length == 0 || this.materialModels[0] == "") {
      this.materialModel = "";
      this.materialModelsError = "Please choose Material";
      return;
    }
    // if( this.qtyModels.length ==0 || this.qtyModels[0] == "" || this.qtyModels[0] == null || this.qtyModels[0] == undefined){
    //   // this.qtyModel="";
    //   this.qtyModelsError[0]="Please choose  Quantity";
    //   return; 
    // }
    // var len = this.qtyModels.length;
    // for(var i=0; i<len; i++){
    //   if(this.qtyModels[i].includes("-")){
    //     this.qtyModelsError[i]="Quantity Cannot Be Negative";
    //     return
    //   }
    // }


    var poNumberModelInitial = this.poNumberModel;
    this.loading = true;
    var poCreation = new CreatePoDto(this.customerModal, this.customerLocationIdsModel, this.customerPOType, this.poNumberModel, this.distributorModel, this.materialNQualityArray, this.noOfPO, this.cutomerName);
    this.httpClient.createPO(poCreation).subscribe(
      data => {
        this.reset(checkBox, isHidden);
        this.loading = false;
        this.poCreationResponse = data.isSaved;
        this.isCreatedPO = this.poCreationResponse;
        if (this.poCreationResponse.includes(",")) {
          this.poCreationResponse = this.poCreationResponse.substring(1, this.poCreationResponse.length - 1);
          this.poCreationResponseListTemp = this.poCreationResponse.split(",");
          var len = this.poCreationResponseListTemp.length;
          for (var i = 0; i < len; i++) {
            var poCreationResponseTemp = this.poCreationResponseListTemp[i];
            var poCreationResponseTemp1 = poCreationResponseTemp.split("=>");
            var poCreationResponseSuccessfulTemp = poCreationResponseTemp1[0];
            if (i == 0) {
              var poNumberToXml = poCreationResponseSuccessfulTemp.split(" ")[0] + "_PO.xml"
            } else {
              var poNumberToXml = poCreationResponseSuccessfulTemp.split(" ")[1] + "_PO.xml"
            }
            var poCreationResponseDateFormat = poCreationResponseTemp1[1] + poNumberToXml;
            var poCreationResponseXmlTemp = poCreationResponseTemp1[2];
            this.poCreationResponseList.push(poCreationResponseSuccessfulTemp);
            // this.poCreationXmlResponseDateFormatList.push(poCreationResponseDateFormat);
            this.poCreationXmlResponseList.push(poCreationResponseXmlTemp);
            this.DownloadxmlShowmessageList.push(new DownloadxmlShowmessage(poCreationResponseDateFormat, poCreationResponseSuccessfulTemp));
          }

        } else {

          this.poCreationResponse = this.poCreationResponse.substring(1, this.poCreationResponse.length - 1);
          var poCreationResponseTemp1 = this.poCreationResponse.split("=>");
          var poCreationResponseSuccessfulTemp = poCreationResponseTemp1[0];
          var poCreationResponseDateFormat = poCreationResponseTemp1[1] + poCreationResponseSuccessfulTemp.split(" ")[0] + "_PO.xml";
          var poCreationResponseXmlTemp = poCreationResponseTemp1[2];
          this.poCreationResponseList.push(poCreationResponseSuccessfulTemp);
          // this.poCreationXmlResponseDateFormatList.push(poCreationResponseDateFormat);
          if (poCreationResponseXmlTemp == " " || poCreationResponseXmlTemp == "" || poCreationResponseXmlTemp == null || poCreationResponseXmlTemp == undefined) {
            this.isXmlAvailable = false;
          } else {
            this.isXmlAvailable = true;
          }
          this.poCreationXmlResponseList.push(poCreationResponseXmlTemp);
          this.DownloadxmlShowmessageList.push(new DownloadxmlShowmessage(poCreationResponseDateFormat, poCreationResponseSuccessfulTemp));
        }
        this.isStatus = true;

      }
    )

  }
  isXmlAvailable: boolean = true;
  DownloadxmlShowmessageList: DownloadxmlShowmessage[] = [];
  poCreationResponseListTemp: string[] = [];
  poCreationResponseList: string[] = [];
  poCreationXmlResponseList: string[] = [];
  poCreationXmlResponseDateFormatList: string[] = [];
  fileXmlUrl;
  isCreatedPO: string = "";
  downloadXmlData(index) {
    var data = this.poCreationXmlResponseList[index];
    const blob = new Blob([data], { type: 'application/xml' });
    this.fileXmlUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
    this.poCreationResponse = "";
    this.poCreationResponse = this.isCreatedPO;



  }
  cutomerName: string;
  getCustomerName(event) {
    this.cutomerName = event.target.options[event.target.selectedIndex].text;
    this.materialNQualityArray = [];
    this.materialNQualityArray.push(new MaterialAndQualityDto("", "", ""));
    console.log("this.materialNQualityArray[0].material >> " + this.materialNQualityArray[0].material);
    console.log("this.materialNQualityArray[0].quality >> " + this.materialNQualityArray[0].quality);

  }
  getMaterials(customerModal) {
    this.isValidData = "";
    this.loading = true;
    this.httpClient.getMaterials(customerModal).subscribe(
      data => {
        this.materialsList = data;
        this.loading = false;
      }
    )
  }
  tempArray: number[] = [];
  realIndex: number = 0;
  materialNQualityArrayTemp: MaterialAndQualityDto[] = [];
  materialModelsTemp: string[] = [];
  qtyModelsTemp: string[] = [];

  deleteNewMaterial(index) {
    var len = this.rowCountList.length;
    var len1 = this.materialNQualityArray.length;
    var lenMaterial = this.materialModels.length;
    var lenQty = this.qtyModels.length;
    if (index != 0) {
      for (var i = 0; i < len; i++) {
        if (i != index) {
          this.tempArray[this.realIndex] = this.rowCountList[i]
          this.materialNQualityArrayTemp[this.realIndex] = this.materialNQualityArray[i]
          this.materialModelsTemp[this.realIndex] = this.materialModels[i]
          this.qtyModelsTemp[this.realIndex] = this.qtyModels[i]
          this.realIndex = this.realIndex + 1;
        }
      }

      console.log(" deleted index  > " + index + "     deleted Element > " + this.rowCountList[index] + "    after Deletion > " + this.tempArray + "  materialModels >>" + this.materialModels[len] + "  qtyModels > " + this.qtyModels[len]);
      this.realIndex = 0;
      this.rowCountList = [];
      this.rowCountList = this.tempArray;
      this.tempArray = [];

      this.materialModels = [];
      this.materialModels = this.materialModelsTemp;
      this.materialModelsTemp = [];

      this.qtyModels = [];
      this.qtyModels = this.qtyModelsTemp;
      this.qtyModelsTemp = [];

      this.materialNQualityArray = [];
      this.materialNQualityArray = this.materialNQualityArrayTemp;
      this.materialNQualityArrayTemp = [];
      this.indexNumber = this.indexNumber - 1;

    }


  }

  additingMaterialNQuality(index) {    
    if (index != undefined && Number(this.qtyModels[index]) >= 0) {
      // if(this.materialModels[index] != "" && this.qtyModels[index] != ""){
      this.materialNQualityArray[index].material = this.materialModels[index];
      this.materialNQualityArray[index].quality = this.qtyModels[index];
      this.materialNQualityArray[index].customerLineNumber = index + 1;
      this.materialModels[index] = this.materialModels[index];
      this.qtyModels[index] = this.qtyModels[index];      
    }

  }
  indexNumber: number = 0;
  addNewMaterial(index) {
    this.noOfPOError = "";
    var len = this.rowCountList.length;
    this.rowCountList[len] = len;
    var lenArr = this.materialNQualityArray.length;
    var materialNQuality = new MaterialAndQualityDto("", "", "");
    this.materialNQualityArray[lenArr] = materialNQuality;
    this.indexNumber = this.indexNumber + 1;
    this.materialModels[len] = ""
    this.qtyModels[len] = "";
    console.log(" added index  > " + len + "   added elment > " + len + "     after addition > " + this.rowCountList + "  materialModels >>" + this.materialModels[len] + "  qtyModels > " + this.qtyModels[len]);

  }
  reset(checkBox, isHidden) {
    checkBox.checked = false;
    isHidden.type = "hidden";
    this.isHiddenEnabled = false;
    this.noOfPO = undefined;
    this.customerModal = "";
    this.customerLocationIdsModel = "";
    this.customerPOType = "";
    this.poNumberModel = "";
    this.distributorModel = "";
    this.materialModel = "";
    this.qtyModel;
    this.isValidData = "";
    this.number = 1;
    this.materialModels = [];
    this.noOfPO = undefined;
    this.qtyModels = [];
    this.materialModels[0] = "";
    this.materialModels[this.materialModelCount] = "";
    this.qtyModels[this.materialModelCount] = "";
    this.materialsList = [];
    this.distributorModel = ""
    this.customerLocationIdsList = [];
    this.rowCountList = [];
    this.rowCountList[0] = 0;
    this.poCreationResponseListTemp = [];
    this.poCreationResponseList = [];
    this.poCreationXmlResponseList = [];
  }

  isHiddenEnabled: boolean = false;
  isEnabled(checkBox, isHidden) {
    this.isValidData = "";

    if (checkBox.checked == true) {
      isHidden.type = "text";
      this.isHiddenEnabled = true;
    } else {
      isHidden.type = "hidden";
      this.isHiddenEnabled = false;
      this.noOfPO = undefined;
    }

  }
  getDistributors() {
    this.isValidData = "";
    this.loading = true;
    this.httpClient.getDistributors(this.customerModal, this.customerLocationIdsModel).subscribe(
      data => {
        this.distibutorsList = data;
        this.loading = false;
        if (this.distibutorsList.length != 0) {
          this.distributorModel = this.distibutorsList[0].customerLocationId;
        }

        this.isDisabledDistributor = false;

        this.distibutorsList[0].sapShipToNum
        this.getMaterials(this.customerModal);
      }
    )

  }
  // pressingOK(){
  //   this.modalPopup=false;
  //   this.isValidData="";
  //   this.customerLocationIdsModel="";
  //   this.materialsList=[];
  //   this.customerPOType="";
  //   this.poNumberModel="";
  //   this.distributorModel="";
  //   this.materialModels[this.materialModelCount]="";
  //   this.qtyModels[this.materialModelCount]="";
  //   this.isBulkModel=false;
  //   this.loading=true;
  //   this.httpClient.getCustomerLocationIds(this.customerModal).subscribe(
  //     data => {
  //       this.customerLocationIdsList=data;
  //       this.isDisabled=false;
  //       this.loading=false;
  //     }
  //   )

  // }
  pressingCancel() {
    this.modalPopup = false;
    return;
  }
  isOK: boolean = true;
  getCustomerLocationIds(checkBox, isHidden) {
    checkBox.checked = false;
    isHidden.type = "hidden";
    this.isHiddenEnabled = false;
    this.noOfPO = undefined;
    this.isValidData = "";
    this.customerLocationIdsModel = "";
    this.materialsList = [];
    this.customerPOType = "";
    this.poNumberModel = "";
    this.distributorModel = "";
    this.materialModels[this.materialModelCount] = "";
    this.qtyModels[this.materialModelCount] = "";
    this.rowCountList = [];
    this.rowCountList[0] = 0;
    this.isBulkModel = false;
    this.loading = true;
    this.getPOTypes();
    this.httpClient.getCustomerLocationIds(this.customerModal).subscribe(
      data => {
        this.customerLocationIdsList = data;
        this.isDisabled = false;
        this.loading = false;
      }
    )


  }
  getCustomersName() {
    this.isValidData = "";
    this.loading = true;
    this.httpClient.getPartnerListMSO().subscribe(
      data => {        
        this.customerNameList = data;
        this.loading = false; 
        
        //Below code use to deploy on PROD to create PO on Production only for Axalta Collision Centers
        //Note : Uncomment below code for see all the partner in the customer dropdown
        
          console.log("Distributor logged in");

          let partnerNm = "Axalta Collision Centers";
          this.customerNameFilterList = this.customerNameList.filter((PartnerDto: PartnerDto) => PartnerDto.partnerName === partnerNm);
          this.customerNameList = this.customerNameFilterList; 
        
      }
    )


  } 
}
